import { render, staticRenderFns } from "./d2-container-ghost.vue?vue&type=template&id=50087654&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "d2-container-ghost.vue"
export default component.exports